import axios from 'axios'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

import TransformOptions from '@/mixins/TransformOptions.js'
import { eventBus } from '@/vcs/_shared/eventBus'
import CreateOption from '@/mixins/CreateOption.js'

export default {
  name: 'UserSearch',
  components: { vSelect },
  mixins: [TransformOptions, CreateOption],
  props: ['companyName'],
  data: function () {
    return {
      user: null,
      users: []
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp',
      deviceId: 'getDeviceId',
      userToken: 'getUserToken'
    })
  },
  mounted() {},
  methods: {
    fetchUsers(search, loading) {
      eventBus.$emit('refresh-token-via-websockets')

      if (search.length >= 3) {
        loading(true)
        axios({
          method: 'get',
          url: `collection_points/${this.deviceId}/users`,
          params: {
            'q[query]': search
          }
        })
          .then((response) => {
            let threeFirstUsers = response.data.slice(0, 3)
            this.users = this.transformOptions(threeFirstUsers)
          })
          .catch((error) => {
            this.$errorHumanized(error)
          })
          .finally(() => {
            loading(false)
          })
      } else if (search.length == 0) {
        this.users = []
      }
    },
    clearUserSelect() {
      this.$slideUp()
      this.user = null
      this.$emit('user-found', null)
      this.$emit('company-name-changed', '')
    },
    userSelectHandler(user) {
      console.log('userSelectHandler', user)
      if (user == null) {
        this.clearUserSelect()
      } else if (this.isUserCreated(user)) {
        this.$emit('company-name-changed', user.itemData)
      } else {
        this.user = user
        this.$emit('user-found', user)
      }
    },
    isUserCreated(user) {
      return !user?.hasOwnProperty('id')
    }
  }
}
